import styled from 'styled-components';
import { COLORS } from '../../Styles/Colors';
import { FORM } from './formStyles';

export const FormShell = styled.div<{ $compact?: boolean; $embedded?: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: ${({ $compact, $embedded }) => ($embedded ? '100%' : $compact ? '560px' : '820px')};
  margin: 0 auto;
  background: ${COLORS.white};
  border: ${({ $embedded }) => ($embedded ? 'none' : `1px solid ${FORM.border}`)};
  border-radius: ${({ $embedded }) => ($embedded ? '0' : FORM.borderRadius)};
  box-shadow: ${({ $embedded }) =>
    $embedded ? 'none' : '0 1px 3px rgba(0, 0, 0, 0.06), 0 4px 12px rgba(0, 0, 0, 0.04)'};
  overflow: hidden;
`;

export const FormBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${FORM.sectionGap};
  padding: 28px 32px;

  @media (max-width: 640px) {
    padding: 20px 16px;
  }
`;

export const FormHeader = styled.div<{ $subtitleOnly?: boolean }>`
  padding: ${({ $subtitleOnly }) => ($subtitleOnly ? '0 32px' : '20px 32px 0')};
  border-bottom: ${({ $subtitleOnly }) => ($subtitleOnly ? 'none' : `1px solid ${FORM.border}`)};
  background: ${({ $subtitleOnly }) =>
    $subtitleOnly ? 'transparent' : `linear-gradient(to bottom, ${FORM.surface}, ${COLORS.white})`};

  @media (max-width: 640px) {
    padding: ${({ $subtitleOnly }) => ($subtitleOnly ? '0 16px' : '16px 16px 0')};
  }
`;

export const FormTitle = styled.h2`
  margin: 0 0 6px;
  color: ${FORM.text};
  font-size: 1.25rem;
  font-weight: 700;
  letter-spacing: -0.01em;
`;

export const FormSubtitle = styled.p`
  margin: 0 0 20px;
  color: ${FORM.textMuted};
  font-size: 0.875rem;
  line-height: 1.5;
`;

export const FormSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${FORM.fieldGap};
`;

export const SectionTitle = styled.h3`
  margin: 0;
  padding-bottom: 8px;
  border-bottom: 2px solid ${COLORS.teal};
  color: ${COLORS.teal};
  font-size: 0.8125rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
`;

export const SectionDescription = styled.p`
  margin: -4px 0 4px;
  color: ${FORM.textMuted};
  font-size: 0.8125rem;
  line-height: 1.55;
`;

export const FormGrid = styled.div<{ $columns?: 1 | 2 | 3 }>`
  display: grid;
  grid-template-columns: repeat(${({ $columns = 2 }) => $columns}, 1fr);
  gap: ${FORM.fieldGap} 20px;

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

export const FormFullWidth = styled.div`
  grid-column: 1 / -1;
`;

export const FormRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${FORM.fieldGap};
  align-items: flex-start;

  @media (max-width: 640px) {
    flex-direction: column;

    & > * {
      width: 100%;
    }
  }
`;

export const FormDivider = styled.hr`
  border: none;
  border-top: 1px solid ${FORM.border};
  margin: 4px 0;
`;

export const FormMessage = styled.div<{ $type: 'error' | 'success' | 'info' }>`
  padding: 12px 16px;
  border-radius: ${FORM.fieldRadius};
  font-size: 0.875rem;
  line-height: 1.45;
  background: ${({ $type }) =>
    $type === 'error' ? `${COLORS.red}10` : $type === 'success' ? `${COLORS.success}12` : `${COLORS.teal}10`};
  border: 1px solid
    ${({ $type }) => ($type === 'error' ? `${COLORS.red}40` : $type === 'success' ? `${COLORS.success}50` : `${COLORS.teal}35`)};
  color: ${({ $type }) => ($type === 'error' ? COLORS.red : $type === 'success' ? COLORS.success : COLORS.teal)};
`;
